document.addEventListener("DOMContentLoaded", function () {
    const isVerified = localStorage.getItem("age_verified");

    if (isVerified) return;

    const popup = document.getElementById("age-popup");
    const yesBtn = document.getElementById("age-yes");

    if (!popup || !yesBtn) return;

    popup.classList.remove("hidden");
    document.body.classList.add("age-verification-bg-no-scroll");

    yesBtn.addEventListener("click", function () {
        localStorage.setItem("age_verified", "true");
        popup.classList.add("hidden");
        document.body.classList.remove("age-verification-bg-no-scroll");
    });
});
